window.getLoaderBlock = function() {
    return $(`
        <div class="loader">
            <svg aria-labelledby="results-loader-3-aria" role="img" width="100%" height="176px">
                <rect role="presentation" x="0" y="0" width="100%" height="100%" clip-path="url(#results-loader-3-diff)" style="fill:url('#results-loader-3-animated-diff')"></rect>
                <defs>
                    <clipPath id="results-loader-3-diff">
                        <rect x="0" y="0" rx="8" ry="8" width="282" height="80"></rect>
                        <rect x="0" y="88" rx="8" ry="8" width="282" height="80"></rect>
                    </clipPath>
                    <linearGradient id="results-loader-3-animated-diff">
                        <stop offset="0%" stop-color="#f7f7f7" stop-opacity="1">
                            <animate attributeName="offset" values="-2; -2; 1" keyTimes="0; 0.25; 1"
                                     dur="2s" repeatCount="indefinite"></animate>
                        </stop>
                        <stop offset="50%" stop-color="#f2f2f2" stop-opacity="1">
                            <animate attributeName="offset" values="-1; -1; 2" keyTimes="0; 0.25; 1"
                                     dur="2s" repeatCount="indefinite"></animate>
                        </stop>
                        <stop offset="100%" stop-color="#f7f7f7" stop-opacity="1">
                            <animate attributeName="offset" values="0; 0; 3" keyTimes="0; 0.25; 1"
                                     dur="2s" repeatCount="indefinite"></animate>
                        </stop>
                    </linearGradient>
                </defs>
            </svg>
        </div>
    `)
}

window.loadMoreHotelPackages = function(page) {
    const loadMoreButton = $('#loadMoreHotelPackages')
    const packageListBlock = $('#packageList')

    $.ajax({
        url: `${window.location.href}/packages`,
        type: 'GET',
        dataType: 'json',
        data: {
            'searchData': searchData,
            'page': page
        },
        success: function (data) {
            const travelPackages = data.packages
            const nextPage = data.nextPage

            if(travelPackages.length > 1) {
                travelPackages.forEach(function(packageItem) {
                    // Render package item
                    $(packageListBlock).append(`
                        <div name="package" id="${packageItem.key}" class="block--item">
                            <label class="checkbox-wrap" style="margin-bottom: 0 !important;">
                                <input type="checkbox" onchange="changePackageOption('${packageItem.key}')">
                            </label>
                            <p>${translations.hotel.payment.price}:<br><span>${renderPrice(packageItem.price)}</span></p>
                            <p>${translations.hotel.flight.departure}:<br><strong>${packageItem.departureDate} - ${packageItem.returnDate}</strong></p>
                            <p>${translations.hotel.room.nights}:<br><strong>${packageItem.nightCount}</strong></p>
                            <p>${translations.hotel.room.type}:<br><strong>${packageItem.roomTitle}</strong></p>
                            <p>${translations.hotel.room.catering}:<br><strong>${packageItem.mealTitle}</strong></p>
                            <p>${translations.hotel.payment.tour_operator}:<br><strong>Coral Travel</strong></p>
                        </div>
                    `)
                })
            }
            if(nextPage > 0 && travelPackages.length > 0) {
                loadMoreHotelPackages(nextPage)
            }
            if(nextPage == null) {
                $('#hotelPackageLoader').remove()
            }
        }
    })
}

window.changePackageOption = function(key) {
    const flightInfoBlock = $('#flightInfo')
    const hotelInfoBlock = $('#hotelInfo')
    const priceInfoBlock = $('#priceInfo')
    const paymentIntoBlock = $('#paymentInfo')

    $(flightInfoBlock).empty()
    $(hotelInfoBlock).empty()
    $(priceInfoBlock).empty()
    $(paymentIntoBlock).empty()

    $(flightInfoBlock).append(getLoaderBlock())
    $(hotelInfoBlock).append(getLoaderBlock())
    $(priceInfoBlock).append(getLoaderBlock())
    $(paymentIntoBlock).append(getLoaderBlock())

    $('div[name="package"]').each(function() {
        if($(this).attr('id') == key) {
            $(this).find('input[type="checkbox"]').prop('checked', true)
        } else {
            $(this).find('input[type="checkbox"]').prop('checked', false)
        }
    })

    $.ajax({
        url: `${window.location.href}/package/${key}`,
        type: 'GET',
        dataType: 'json',
        data: {
            'searchData': searchData
        },
        success: function (packageItem) {
            $(flightInfoBlock).empty()
            $(hotelInfoBlock).empty()
            $(priceInfoBlock).empty()
            $(paymentIntoBlock).empty()

            if(packageItem === false) {
                location.reload()
            }

            closeModal('modal')

            // if is object and not empty object
            if(typeof packageItem === 'object' && Object.keys(packageItem).length > 0) {
                let flightRoute = '';
                let count = 1;
                let departFlight = '';
                let returnFlight = '';

                packageItem.flightRoute.forEach(function(city) {
                    flightRoute += city
                    if(count < packageItem.flightRoute.length) {
                        flightRoute += '<span>&nbsp;&gt;&nbsp;</span>'
                    }
                    count++
                })

                if(packageItem.departFlight) {
                    departFlight = `<div class="flight--info">
                        <h4>${packageItem.departFlight.from_airport} - ${packageItem.departFlight.to_airport}</h4>
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${packageItem.departFlight.departure_time}</h4>
                        <p>${translations.hotel.flight.arrival}:</p>
                        <h4>${packageItem.departFlight.arrival_time}</h4>
                        <p>${translations.hotel.flight.flight_code}: ${packageItem.departFlight.flight_code}</p>
                    </div>`
                }

                if(packageItem.returnFlight) {
                    returnFlight = `<div class="flight--info">
                        <h4>${packageItem.returnFlight.from_airport} - ${packageItem.returnFlight.to_airport}</h4>
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${packageItem.returnFlight.departure_time}</h4>
                        <p>${translations.hotel.flight.arrival}:</p>
                        <h4>${packageItem.returnFlight.arrival_time}</h4>
                        <p>${translations.hotel.flight.flight_code}: ${packageItem.returnFlight.flight_code}</p>
                    </div>`
                }

                $(flightInfoBlock).append(`
                    <div class="complete--flex-col-item-text">
                        ${flightRoute}
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${packageItem.departureDate}</h4>
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.return}:</p>
                        <h4>${packageItem.returnDate}</h4>
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.seat_class}:</p>
                        <h4>${packageItem.seatClassTitle}</h4>
                    </div>
                `)

                if(departFlight || returnFlight) {
                    $(flightInfoBlock).append(`
                        <div class="info-btn">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.8C17.9647 22.8 22.8 17.9647 22.8 12C22.8 6.03532 17.9647 1.2 12 1.2C6.03532 1.2 1.2 6.03532 1.2 12C1.2 17.9647 6.03532 22.8 12 22.8ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#CDDC29"/>
                                <path d="M11.9878 18.6C11.7238 18.6 11.5018 18.516 11.3218 18.348C11.1538 18.168 11.0698 17.946 11.0698 17.682V9.672C11.0698 9.396 11.1538 9.174 11.3218 9.006C11.5018 8.838 11.7238 8.754 11.9878 8.754C12.2638 8.754 12.4858 8.838 12.6538 9.006C12.8218 9.174 12.9058 9.396 12.9058 9.672V17.682C12.9058 17.946 12.8218 18.168 12.6538 18.348C12.4858 18.516 12.2638 18.6 11.9878 18.6ZM11.9878 7.152C11.6638 7.152 11.3818 7.038 11.1418 6.81C10.9138 6.57 10.7998 6.288 10.7998 5.964C10.7998 5.64 10.9138 5.364 11.1418 5.136C11.3818 4.896 11.6638 4.776 11.9878 4.776C12.3118 4.776 12.5878 4.896 12.8158 5.136C13.0558 5.364 13.1758 5.64 13.1758 5.964C13.1758 6.288 13.0558 6.57 12.8158 6.81C12.5878 7.038 12.3118 7.152 11.9878 7.152Z" fill="#CDDC29"/>
                            </svg>
                        </div>
                        <div class="flight-info-hover">
                            ${departFlight}
                            ${returnFlight}
                        </div>
                    `)
                }

                $(hotelInfoBlock).append(`
                    <p>${translations.hotel.room.nights}: <strong>${packageItem.nightCount}</strong></p>
                    <p>${translations.hotel.room.catering}: <strong>${packageItem.mealTitle}</strong></p>
                    <p>
                        ${translations.hotel.room.travelers}:
                        <strong>
                            ${packageItem.adultCount} ${translations.hotel.room.adults}
                            ${packageItem.childCount > 0 ? `<br>${packageItem.childCount} ${translations.hotel.room.children}` : ''}
                        </strong>
                    </p>
                    <p>${translations.hotel.room.type}: <strong>${packageItem.roomTitle}</strong></p>
                    <button id="openModal" class="change-btn">${translations.hotel.room.choose_other}<span>${translations.hotel.room.choose_other_caption}</span></button>
                `)

                initModal('modal', 'openModal', 'closeModal')

                $(priceInfoBlock).append(`
                    <p>${translations.hotel.payment.price}:</p>
                    <h2>${renderPrice(packageItem.price)}</h2>
                    <form action="${window.location.href}/reserve" method="POST">
                        <input type="hidden" name="_token" value="${$('meta[name=csrf-token]').attr('content')}">
                        <input type="hidden" name="key" value="${packageItem.key}">
                        <button type="submit">${translations.hotel.reserve}</button>
                        <p class="disclaimer">${translations.hotel.payment.price_disclaimer}</p>
                    </form>
                `)

                if(packageItem.prepaymentPrice > 0) {
                    $(paymentIntoBlock).append(`
                        <p>${translations.hotel.payment.prepayment}: <strong>${renderPrice(packageItem.prepaymentPrice)}</strong></p>
                    `)
                }

                $(paymentIntoBlock).append(`
                    <p>${translations.hotel.payment.payment_due}: <strong>${packageItem.paymentDueDate}</strong></p>
                    <p>${translations.hotel.payment.tour_operator}: <strong>Coral Travel</strong></p>
                `)

                if(packageItem.oldPrice > 0) {
                    $(paymentIntoBlock).append(`
                        <p>${translations.hotel.payment.old_price}: <strong>${renderPrice(packageItem.oldPrice)}</strong></p>
                    `)
                }
            }
        }
    })
}

$(function() {
    const flightInfoBlock = $('#flightInfo')
    const hotelInfoBlock = $('#hotelInfo')
    const priceInfoBlock = $('#priceInfo')
    const paymentIntoBlock = $('#paymentInfo')
    const packageListBlock = $('#packageList')

    $(flightInfoBlock).append(getLoaderBlock())
    $(hotelInfoBlock).append(getLoaderBlock())
    $(priceInfoBlock).append(getLoaderBlock())
    $(paymentIntoBlock).append(getLoaderBlock())

    $.ajax({
        url: `${window.location.href}/packages`,
        type: 'GET',
        dataType: 'json',
        data: {
            'searchData': searchData
        },
        success: function (data) {
            const travelPackages = data.packages
            const nextPage = data.nextPage
            $(flightInfoBlock).empty()
            $(hotelInfoBlock).empty()
            $(priceInfoBlock).empty()
            $(paymentIntoBlock).empty()

            if(travelPackages.length > 0) {
                const firstPackage = travelPackages[0]
                let flightRoute = '';
                let count = 1;
                let departFlight = null;
                let returnFlight = null;

                firstPackage.flightRoute.forEach(function(city) {
                    flightRoute += city
                    if(count < firstPackage.flightRoute.length) {
                        flightRoute += '<span>&nbsp;&gt;&nbsp;</span>'
                    }
                    count++
                })

                if(firstPackage.departFlight) {
                    departFlight = `<div class="flight--info">
                        <h4>${firstPackage.departFlight.from_airport} - ${firstPackage.departFlight.to_airport}</h4>
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${firstPackage.departFlight.departure_time}</h4>
                        <p>${translations.hotel.flight.arrival}:</p>
                        <h4>${firstPackage.departFlight.arrival_time}</h4>
                        <p>${translations.hotel.flight.flight_code}: ${firstPackage.departFlight.flight_code}</p>
                    </div>`
                }

                if(firstPackage.returnFlight) {
                    returnFlight = `<div class="flight--info">
                        <h4>${firstPackage.returnFlight.from_airport} - ${firstPackage.returnFlight.to_airport}</h4>
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${firstPackage.returnFlight.departure_time}</h4>
                        <p>${translations.hotel.flight.arrival}:</p>
                        <h4>${firstPackage.returnFlight.arrival_time}</h4>
                        <p>${translations.hotel.flight.flight_code}: ${firstPackage.returnFlight.flight_code}</p>
                    </div>`
                }

                $(flightInfoBlock).append(`
                    <div class="complete--flex-col-item-text">
                        ${flightRoute}
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.departure}:</p>
                        <h4>${firstPackage.departureDate}</h4>
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.return}:</p>
                        <h4>${firstPackage.returnDate}</h4>
                    </div>
                    <div class="flight--info">
                        <p>${translations.hotel.flight.seat_class}:</p>
                        <h4>${firstPackage.seatClassTitle}</h4>
                    </div>
                `)

                if(departFlight || returnFlight) {
                    $(flightInfoBlock).append(`
                        <div class="info-btn">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22.8C17.9647 22.8 22.8 17.9647 22.8 12C22.8 6.03532 17.9647 1.2 12 1.2C6.03532 1.2 1.2 6.03532 1.2 12C1.2 17.9647 6.03532 22.8 12 22.8ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#CDDC29"/>
                                <path d="M11.9878 18.6C11.7238 18.6 11.5018 18.516 11.3218 18.348C11.1538 18.168 11.0698 17.946 11.0698 17.682V9.672C11.0698 9.396 11.1538 9.174 11.3218 9.006C11.5018 8.838 11.7238 8.754 11.9878 8.754C12.2638 8.754 12.4858 8.838 12.6538 9.006C12.8218 9.174 12.9058 9.396 12.9058 9.672V17.682C12.9058 17.946 12.8218 18.168 12.6538 18.348C12.4858 18.516 12.2638 18.6 11.9878 18.6ZM11.9878 7.152C11.6638 7.152 11.3818 7.038 11.1418 6.81C10.9138 6.57 10.7998 6.288 10.7998 5.964C10.7998 5.64 10.9138 5.364 11.1418 5.136C11.3818 4.896 11.6638 4.776 11.9878 4.776C12.3118 4.776 12.5878 4.896 12.8158 5.136C13.0558 5.364 13.1758 5.64 13.1758 5.964C13.1758 6.288 13.0558 6.57 12.8158 6.81C12.5878 7.038 12.3118 7.152 11.9878 7.152Z" fill="#CDDC29"/>
                            </svg>
                        </div>
                        <div class="flight-info-hover">
                            ${departFlight}
                            ${returnFlight}
                        </div>
                    `)
                }

                $(hotelInfoBlock).append(`
                    <p>${translations.hotel.room.nights}: <strong>${firstPackage.nightCount}</strong></p>
                    <p>${translations.hotel.room.catering}: <strong>${firstPackage.mealTitle}</strong></p>
                    <p>
                        ${translations.hotel.room.travelers}:
                        <strong>
                            ${firstPackage.adultCount} ${translations.hotel.room.adults}
                            ${firstPackage.childCount > 0 ? `<br>${firstPackage.childCount} ${translations.hotel.room.children}` : ''}
                        </strong>
                    </p>
                    <p>${translations.hotel.room.type}: <strong>${firstPackage.roomTitle}</strong></p>
                    ${ travelPackages.length > 1 ? `
                        <button id="openModal" class="change-btn">${translations.hotel.room.choose_other}<span>${translations.hotel.room.choose_other_caption}</span></button>
                    ` : ''}
                `)

                if(travelPackages.length > 1) {
                    initModal('modal', 'openModal', 'closeModal')
                }

                $(priceInfoBlock).append(`
                    <p>${translations.hotel.payment.price}:</p>
                    <h2>${renderPrice(firstPackage.price)}</h2>
                    <form action="${window.location.href}/reserve" method="POST">
                        <input type="hidden" name="_token" value="${$('meta[name=csrf-token]').attr('content')}">
                        <input type="hidden" name="key" value="${firstPackage.key}">
                        <button type="submit">${translations.hotel.reserve}</button>
                        <p class="disclaimer">${translations.hotel.payment.price_disclaimer}</p>
                    </form>
                `)

                if(firstPackage.prepaymentPrice > 0) {
                    $(paymentIntoBlock).append(`
                        <p>${translations.hotel.payment.prepayment}: <strong>${renderPrice(firstPackage.prepaymentPrice)}</strong></p>
                    `)
                }

                $(paymentIntoBlock).append(`
                    <p>${translations.hotel.payment.payment_due}: <strong>${firstPackage.paymentDueDate}</strong></p>
                    <p>${translations.hotel.payment.tour_operator}: <strong>Coral Travel</strong></p>
                `)

                if(firstPackage.oldPrice > 0) {
                    $(paymentIntoBlock).append(`
                        <p>${translations.hotel.payment.old_price}: <strong>${renderPrice(firstPackage.oldPrice)}</strong></p>
                    `)
                }

                if(travelPackages.length > 1) {
                    travelPackages.forEach(function(packageItem, indexKey) {
                        // Render package item
                        $(packageListBlock).append(`
                            <div name="package" id="${packageItem.key}" class="block--item">
                                <label class="checkbox-wrap" style="margin-bottom: 0 !important;">
                                    <input type="checkbox" onchange="changePackageOption('${packageItem.key}')" ${indexKey === 0 ? 'checked' : ''}>
                                </label>
                                <p>${translations.hotel.payment.price}:<br><span>${renderPrice(packageItem.price)}</span></p>
                                <p>${translations.hotel.flight.departure}:<br><strong>${packageItem.departureDate} - ${packageItem.returnDate}</strong></p>
                                <p>${translations.hotel.room.nights}:<br><strong>${packageItem.nightCount}</strong></p>
                                <p>${translations.hotel.room.type}:<br><strong>${packageItem.roomTitle}</strong></p>
                                <p>${translations.hotel.room.catering}:<br><strong>${packageItem.mealTitle}</strong></p>
                                <p>${translations.hotel.payment.tour_operator}:<br><strong>Coral Travel</strong></p>
                            </div>
                        `)
                    })
                }

                if(nextPage && travelPackages.length > 0) {
                    loadMoreHotelPackages(data.nextPage)
                    $(packageListBlock).prepend(`
                        <span id="hotelPackageLoader" class="more-btn">
                            <i class="btn-loader"></i>
                            ${translations.travel_searching_packages}
                        </span>
                    `)
                }
            }
        }
    })
});
